<template>
  <b-tabs content-class="mt-3">
    <b-tab title="Thường" active>
      <b-row>
        <b-col lg="6" class="mb-4">
          <b-form>
            <b-form-group label="Tài khoản">
              <account-select v-model="account_id" :inputStyte="{width:'250px'}" addBtn :change="onAccountSelect"/>
            </b-form-group>
            <b-form-group label="Khách hàng">
              <customer-select v-model="customer_id" :reduce="opt => opt.id" :inputStyte="{width:'250px'}" addBtn/>
            </b-form-group>
            <b-form-group label="Loại">
              <v-select style="width:250px;" v-model="typeformulaChoose" :reduce="option => option.value" :clearable="false" :options="formulaOptions" placeholder="Chọn"/>
            </b-form-group>
            <b-form-group label="Công thức" v-show="typeformulaChoose === 'single_formula'">
              <formular-select v-model="formula_id" :formula-options-override="formulaByNetworkOptions" :network-id="networkId" :inputStyte="{width:'250px'}" addBtn />
            </b-form-group>
            <b-form-group label="Nhóm Công thức" v-show="typeformulaChoose === 'group_formula'">
              <group-formular-select v-model="group_formular_id" :inputStyte="{width:'250px'}"/>
            </b-form-group>

            <b-form-group>
              <b-row>
                <b-col lg="6">
                  <label>Tiền hồi khi WIN</label>
                  <b-input-group>
                    <template #append>
                      <b-input-group-text>%</b-input-group-text>
                    </template>
                    <b-form-input v-model="return_win"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="6">
                  <label>Tiền hồi khi LOSE</label>
                  <b-input-group>
                    <template #append>
                      <b-input-group-text>%</b-input-group-text>
                    </template>
                    <b-form-input v-model="return_lose"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
            <div class="d-flex justify-content-center">
              <b-button :variant="'primary'" @click="createNormalFormula">Xác nhận</b-button>
            </div>
          </b-form>
        </b-col>
        <b-col lg="6">
          <b-table
            id="customer-list-table"
            ref="customerListTableRef"
            :items="formulaList"
            :fields="formulaFields"
            :striped="false"
            :outlined="true"
            :small="true"
            :hover="true"
            :primary-key="'id'"
            class="table-striped table-bordered"
            role="grid"
            aria-describedby="user-list-page-info"
          >
            <template #top-row v-if="formulaList.length === 0">
              <!-- Adding &nbsp; to the cell so that it maintains the standard cell height -->
              <td colspan="4" align="center">Chưa có</td>
            </template>
            <template v-slot:cell(money_back)="data">
              <span>{{ data.item.money_back_win }}% / {{ data.item.money_back_lose }}%</span>
            </template>
            <template v-slot:cell(action)="data">
              <div class="flex align-items-center list-user-action">
                <i class="las la-trash-alt text-red" @click="removeFormula(data.item.id, data.item.name)"></i>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-tab>
    <b-tab title="Cho ké">
      <b-row>
        <b-col lg="6" class="mb-4">
          <b-form>
            <b-form-group label="Tài khoản">
              <account-select v-model="account_id_2" :inputStyte="{width:'250px'}" addBtn :change="onAccount2Select"/>
            </b-form-group>
            <b-form-group label="Kiểu công thức">
              <b-input-group>
                <v-select v-model="formula_type_id_2" :reduce="opt => opt.id" :options="formularTypesByNetworkOptions" @input="formularTypeChange" placeholder="Chọn" :style="{width:'250px'}"/>
              </b-input-group>
            </b-form-group>
            <b-form-group label="Loại tiền">
              <v-select style="width:120px; float:left; margin-right: 10px;" v-model="curreny_id_2" :reduce="opt => opt.serverId" :options="moneyTypeOptions" placeholder="Chọn"/>
              <v-select style="width:120px; float:left;" v-model="curreny_to_id_2" :reduce="opt => opt.serverId" :options="moneyTypeOptions" placeholder="Chọn"/>
            </b-form-group>
            <p class="mb-2" style="font-size: 0.8rem;">
              <b>Kết quả = </b> {{formularTypeDescription}}
            </p>
            <table class="table table-bordered">
              <thead>
              <tr>
                <th width="80" align="right"></th>
                <th style="text-align: center">LẤY VỀ</th>
                <th style="text-align: center">ĐƯA ĐI</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Hệ số</td>
                <td><b>
                  <b-form-input v-model="ratio"/>
                </b></td>
                <td><b>
                  <b-form-input v-model="ratio_out"/>
                </b></td>
              </tr>
              <tr>
                <td>Giá thầu</td>
                <td><b>
                  <b-form-input v-model="price"/>
                </b></td>
                <td><b>
                  <b-form-input v-model="price_out"/>
                </b></td>
              </tr>
              </tbody>
            </table>
            <b-form-group>
              <b-row>
                <b-col lg="6">
                  <label>Tiền hồi khi WIN</label>
                  <b-input-group>
                    <template #append>
                      <b-input-group-text><strong class="text-primary">%</strong></b-input-group-text>
                    </template>
                    <b-form-input v-model="return_win_2"/>
                  </b-input-group>
                </b-col>
                <b-col lg="6">
                  <label>Tiền hồi khi LOSE</label>
                  <b-input-group>
                    <template #append>
                      <b-input-group-text><strong class="text-primary">%</strong></b-input-group-text>
                    </template>
                    <b-form-input v-model="return_lose_2"/>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form-group>
            <table class="table table-bordered customer-table">
              <thead>
              <tr>
                <th width="170" class="text-center">KHÁCH HÀNG</th>
                <th width="60" class="text-center">%</th>
                <th width="90" class="text-center"></th>
                <th width="20"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(ce, index) in customerList" :key="ce.increase_key">
                <td>
                  <customer-select v-model="ce.customer_id" :reduce="opt => opt.id" :inputStyte="{width: '155px'}" size="sm" addBtn/>
                </td>
                <td>
                  <b-input-group>
                    <b-form-input v-model="ce.percent"/>
                  </b-input-group>
                </td>
                <td>
                  <trasnfer-receive v-model="ce.transferReceive"/>
                </td>
                <td>
                  <i @click="removeCustomer(index)" class="fa fa-trash-alt"/>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <b-button :variant="'outline-primary'" :size="'sm'" @click="addNewCustomer"><i class="fa fa-plus"/>Thêm</b-button>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-center">
              <b-button :variant="'primary'" @click="createComplexFormula">Xác nhận</b-button>
            </div>
          </b-form>
        </b-col>
        <b-col lg="6">
          <b-table
            id="customer-list-table"
            ref="customerListTableRef"
            :items="formulaList2"
            :fields="formulaFields"
            :striped="false"
            :outlined="true"
            :small="true"
            :hover="true"
            :primary-key="'member_id'"
            class="table-striped table-bordered"
            role="grid"
            aria-describedby="user-list-page-info"
          >
            <template #top-row v-if="formulaList2.length === 0">
              <!-- Adding &nbsp; to the cell so that it maintains the standard cell height -->
              <td colspan="4" align="center">Chưa có</td>
            </template>
            <template v-slot:cell(money_back)="data">
              <span>{{ data.item.money_back_win }}% / {{ data.item.money_back_lose }}%</span>
            </template>
            <template v-slot:cell(action)="data">
              <div class="flex align-items-center list-user-action" v-show="data.item.show_delete">
                <i class="las la-trash-alt text-red" @click="removeComplexFormula(data.item.id, data.item.name)"></i>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-tab>
  </b-tabs>
</template>
<style type="text/css">
.customer-table .vs__selected{
  min-width: 140px;
}
</style>
<script>
import _ from 'lodash'
import CustomerSelect from '../customer/CustomerSelect'
import TrasnferReceive from '../misc/TrasnferReceive'
import { mapActions, mapGetters } from 'vuex'
import AccountSelect from '../account/AccountSelect'
import FormularSelect from '../formular/FormulaSelect'
import api from '../../../store/api'
import GroupFormularSelect from '../group_formular/GroupFormulaSelect'

export default {
  name: 'LinkAttach',
  components: { GroupFormularSelect, FormularSelect, AccountSelect, TrasnferReceive, CustomerSelect },
  async mounted () {
    // must wait to load accounts
    await this.loadAccounts()

    if (this.inputAccountId) {
      this.account_id = this.inputAccountId
      this.account_id_2 = this.inputAccountId
      this.onAccountSelect(this.inputAccountId)
      this.onAccount2Select(this.inputAccountId)
    }

    if (this.networkId) {
      await this.loadFormularByNetwork({
        'network_id': this.networkId
      })
      await this.loadTypeListByNetwork({
        'network_id': this.networkId
      })
    }
  },
  watch: {
    inputAccountId: function (newVal, oldVal) {
      if (newVal) {
        this.account_id = newVal
        this.account_id_2 = newVal
      }
    },
    formularTypesByNetworkOptions: function (newVal, oldVal) {
      if (newVal) {
        // select first
        this.formula_type_id_2 = this.formularTypesByNetworkOptions[0].id
      }
    }
  },
  props: {
    inputAccountId: {
      type: String,
      default: ''
    },
    networkId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      account_id: null,
      customer_id: null,
      formula_id: null,
      group_formular_id: null,
      typeformulaChoose: 'single_formula',
      return_win: 100,
      return_lose: 100,
      selecting_account_id: null,

      account_id_2: null,
      formula_type_id_2: null,
      curreny_id_2: null,
      curreny_to_id_2: null,
      ratio: '',
      ratio_out: '',
      price: '',
      price_out: '',
      return_win_2: 100,
      return_lose_2: 100,
      selecting_account_id_2: null,

      formularTypeChoice: null,
      formularTypeDescription: '',
      customerKey: 1,
      customerList: [
        {
          increase_key: 0,
          customer_id: null,
          percent: 0,
          transferReceive: false
        }
      ],
      formulaList: [
      ],
      formulaList2: [],
      formulaFields: [
        {
          key: 'name',
          label: 'Công thức',
          thStyle: { width: '40%' }
        },
        {
          key: 'member_name',
          label: 'Thành viên',
          class: 'text-center',
          thStyle: { width: '30%' }
        },
        {
          key: 'money_back',
          label: 'Hồi W/L',
          class: 'text-center',
          thStyle: { width: '30%' }
        },
        {
          key: 'action',
          label: '',
          class: 'text-center',
          thStyle: { width: '10%' }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      'fomularTypes': 'Formular/listTypeState',
      'moneyTypeOptions': 'Setting/moneyTypeState',
      'formulaOptions': 'Setting/formulaOptionsState',
      'formulaByNetworkOptions': 'Formular/listByNetworkOptionsState',
      'formularTypesByNetworkOptions': 'Formular/listTypeByNetworkOptionsState',
      'serverError': 'Setting/serverErrorsState'
    })
  },
  methods: {
    onAccountSelect (accountId) {
      api.formular.loadByAccount(accountId).then((data) => {
        this.formulaList = data
        this.selecting_account_id = accountId
      })
    },
    onAccount2Select (accountId) {
      api.formular.loadComplexByAccount(accountId).then((data) => {
        this.formulaList2 = []
        _.each(data, (d) => {
          if (d && d.formula && d.formula.members) {
            _.each(d.formula.members, (x, index) => {
              let objectoAdd = {
                'id': d.id,
                'member_id': x.member_id,
                'name': '',
                'member_name': x.member.name,
                'money_back_win': x.money_back_win,
                'money_back_lose': x.money_back_lose,
                'show_delete': false
              }

              if (index === 0) {
                objectoAdd = Object.assign(objectoAdd, {
                  'name': d.formula.name,
                  'show_delete': true
                })
              }

              this.formulaList2.push(objectoAdd)
            })
          }
        })
      })

      this.selecting_account_id_2 = accountId
    },
    addNewCustomer () {
      // add default object
      this.customerList.push({
        increase_key: this.customerKey++,
        customer_id: null,
        percent: 0,
        transferReceive: false
      })
    },
    removeCustomer (index) {
      this.customerList.splice(index, 1)
    },
    formularTypeChange (event) {
      let formularTypeId = event

      let choiceFormularType = _.first(_.filter(this.fomularTypes, (e) => {
        return e.id === formularTypeId
      }))

      if (choiceFormularType) {
        this.formularTypeDescription = choiceFormularType.description
      }
    },
    removeFormula (id, title) {
      this.$swal({
        title: title,
        text: 'Bạn chắc chắn xóa công thức này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        if (result.isConfirmed) {
          api.formular.deleteByAccount(id).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })
            this.onAccountSelect(this.selecting_account_id)
            this.$emit('removed-link')
          }).catch(() => {
            this.$swal({
              icon: 'error',
              title: 'Lỗi...',
              text: this.serverError
            })
          })
        } else if (result.isDenied) {

        }
      })
    },
    removeComplexFormula (id, title) {
      this.$swal({
        title: title,
        text: 'Bạn chắc chắn xóa công thức này ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Xóa',
        denyButtonText: `Hủy`
      }).then((result) => {
        if (result.isConfirmed) {
          api.formular.deleteComplexByAccount(id).then(async () => {
            this.$swal({
              icon: 'success',
              title: 'Xóa thành công'
            })
            this.onAccount2Select(this.selecting_account_id_2)
            this.$emit('removed-link')
          })
        } else if (result.isDenied) {

        }
      })
    },
    createNormalFormula () {
      let params = {
        'account_id': this.account_id,
        'member_id': this.customer_id,

        'money_back_win': this.return_win, // optional : default 100
        'money_back_lose': this.return_lose // optional : default 100
      }

      if (this.typeformulaChoose === 'single_formula') {
        params = Object.assign(params, {
          'formula_id': this.formula_id,
          'formula_group_id': ''
        })
      }

      if (this.typeformulaChoose === 'group_formula') {
        params = Object.assign(params, {
          'formula_id': '',
          'formula_group_id': this.group_formular_id
        })
      }

      api.formular.createNormalLink(params).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Thêm liên kết thường thành công'
        })
        this.onAccountSelect(this.selecting_account_id)

        this.formula_id = null
        this.group_formular_id = null
        this.$emit('created-link', res)
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    createComplexFormula () {
      let params = {
        'account_id': this.account_id_2,
        'type_id': this.formula_type_id_2,
        'currency_id': this.curreny_id_2,
        'currency_id_to': this.curreny_to_id_2,
        'ratio': this.ratio,
        'price': this.price,
        'ratio_out': this.ratio_out,
        'price_out': this.price_out,
        'money_back_win': this.return_win_2,
        'money_back_lose': this.return_lose_2,
        'member_id': _.map(this.customerList, (e) => {
          return e.customer_id
        }),
        'percentage': _.map(this.customerList, (e) => {
          return e.percent
        }),
        'type_money': _.map(this.customerList, (e) => {
          return e.transferReceive
        })
      }

      api.formular.createComplexLink(params).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Thêm liên kết cho ké thành công'
        })
        this.onAccount2Select(this.selecting_account_id_2)

        this.$emit('created-link', res)
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    ...mapActions({
      'loadFormularByNetwork': 'Formular/loadListByNetwork',
      'loadTypeListByNetwork': 'Formular/loadTypeListByNetwork',
      'loadAccounts': 'Account/loadList'
    })
  }
}
</script>
